import { HotelCardController as HotelCard } from './hotelCardController/hotelCard.controller';

export default HotelCard;
